import i18n from "../../lib/i18n";

export default function DeleteRecord ({loadingDelete, handelDelete, closeDeleteConfirmation}) {

    const t = i18n.t.bind(i18n); 

    
        return(
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">  
                    <div className="bg-furthly py-8 px-12 rounded-md shadow-lg">  
                        <h2 className="text-[20px] text-center text-white font-semibold mb-5">{t("delete_record.confirm_delete")}</h2>  
                        <p className="mb-5 text-white">{t("delete_record.are_you_sure")}</p>  
                        <div className="flex justify-between">  
                            <button  
                                type="button"
                                onClick={closeDeleteConfirmation}  
                                className="mr-2 bg-white hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded"  
                            >  
                                {t("delete_record.cancel")}
                            </button>  
                            <button  
                                onClick={handelDelete}  
                                disabled={loadingDelete}
                                className="bg-danger hover:bg-red-700 text-white font-bold py-2 px-4 rounded"  
                            >  
                            {loadingDelete
                                ?   <div className="animate-spin border-4 border-white border-t-transparent rounded-full w-6 h-6"></div>
                                :   t("delete_record.delete")
                            }     
                            </button> 
                        </div>  
                    </div>  
                </div>  
        );
};